import initUnocssRuntime from '@unocss/runtime'
// Import the preset from its own package, not the `unocss` umbrella: that entry
// pulls the whole toolkit — CLI, every preset, every transformer — into the
// browser graph. Since 66.10 that includes transformer-attributify-jsx and its
// oxc-parser dependency, whose wasm binding does not resolve at build time.
import { presetWind3 } from '@unocss/preset-wind3'
import theme from '@humanoidfr/design-tokens/tailwind'

initUnocssRuntime({
  defaults: {
    presets: [presetWind3({ variablePrefix: 'hdsu-', preflight: false })],
    theme: {
      colors: theme.colors,
      spacing: theme.spacing,
      borderRadius: theme.radius,
      fontSize: theme.fontSize,
      fontWeight: theme.fontWeight,
    },
  },
  ready() {
    document.body.classList.add('uno-ready')
  },
})
